import type { BadgeProps } from 'global/types/props'

export const Badge = ({ text }: BadgeProps) => (
  <div className='bg-secondary rounded-full text-white px-1.5 py-0.5'>{text}</div>
)
